/**
 * @file The Lead time cell of one fetch part. Consumer: `SignifyFetchJobPartTable`.
 * Only a `done` part carries a result, so every other state renders the same em dash rather than an
 * empty cell — a blank reads as missing data, a dash reads as nothing to show yet.
 * `defaultPlannedDeliveryTime` is optional on the vendor's response and is null often enough that
 * its absence is not an error.
 */

import { FC } from 'react';
import { Typography } from 'antd';
import { useSnapshot } from 'valtio';
import type { SignifyFetchPart } from '#types';

const { Text } = Typography;

const SignifyFetchJobPartLeadTimeCell: FC<{ part: SignifyFetchPart }> = ({ part }) => {
  const snap = useSnapshot(part);

  if (snap.state !== 'done') return <Text type="secondary">—</Text>;
  return <Text>{snap.result.defaultPlannedDeliveryTime ?? '—'}</Text>;
};

export default SignifyFetchJobPartLeadTimeCell;
